import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../../hook/useAuth";
import useDelete from "../../../../hook/useDelete";
import useConfirm from "../../../../hook/useConfirm";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../../../config/api";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";


export const EditWheelModel = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const idNumber = useLocation();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [modelName, setModelName] = useState<string>("");
    const [wheelType, setWheelType] = useState<string>("");
    const [brandId, setBrandId] = useState<number>(0);
    const [brands, setBrands] = useState<any[]>([]);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);


    useEffect(() => {
        axios.get(`${baseURL}wheelBrands`)
            .then((response) => {
                setBrands(response?.data?.map((item: any) => {
                    return { value: item.brandId, label: item.brandName }
                }))
            }).catch(error => {
                setBrandId(0);
                setBrands([]);
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        setPleaseWaitPopup(true);
        axios
            .get(`${baseURL}wheelModels/${idNumber?.state}`)
            .then((response) => {
                setModelName(response?.data?.modelName);
                setBrandId(response?.data?.brandId);
                setWheelType(response?.data?.wheelType)
                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .put(
                `${baseURL}wheelModels?userId=${auth?.id}`,
                JSON.stringify({
                    modelId: idNumber?.state,
                    modelName,
                    brandId,
                    wheelType
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }


    const deletingModel = async (id: number) => {

        setDeleteData({
            id: id,
            title: `Delete Year`,
            summary: `Are you sure you want to delete this model?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();

                axios
                    .delete(`${baseURL}wheelModels?id=${id}&userId=${auth?.id}`)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        setConfirmData({
                            title: "Warning",
                            summary: "Delete failed.",
                            confirmBtn: "Ok",
                            isConfirm: (cb: any) => cb(),
                        });

                        setConfirmPopup(true);
                        setPleaseWaitPopup(false);
                    });
            },
        });

        setDeletePopup(true);
    };


    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Edit Model</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Model Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={modelName}
                                                placeholder="Model Name"
                                                onChange={(e) => setModelName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Wheel Type</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={wheelType}
                                                placeholder="Wheel Type"
                                                onChange={(e) => setWheelType(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Brand</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={brandId}
                                                onChange={(e) => setBrandId(Number(e.target.value))}
                                                required
                                            >
                                                {brands?.map((brand: any) => (
                                                    <option key={brand.value} value={brand.value}>
                                                        {brand.label}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => deletingModel(Number(idNumber?.state))}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-red-500 text-white cursor-pointer border border-red-600"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}